import { faTrashCan } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FC, ButtonHTMLAttributes } from "react";

import { cn } from "utils/cn";

type MailInputAbstractProps = ButtonHTMLAttributes<HTMLButtonElement>;

export const DeleteButton: FC<MailInputAbstractProps> = ({ disabled, className, onClick }) => {
  return (
    <button
      type="button"
      className={cn("flex shrink-0 items-center gap-2 px-2", className)}
      disabled={disabled}
      onClick={onClick}
    >
      <FontAwesomeIcon className="h-4 w-3.5 text-text-disabled" icon={faTrashCan} />
      <span className="text-s text-text-gray">削除</span>
    </button>
  );
};
